<script setup lang="ts">
defineProps<{ critical: boolean }>()
const route = useRoute()
const { isEcommerceDisabled } = useAppStore()

const isRestaurantSelected = inject('isRestaurantSelected')
</script>

<template>
  <Header
    v-if="isEcommerceDisabled || isRestaurantSelected || route.path !== '/'"
    :is-landing="false"
  />
  <LandingHeader v-else />
</template>
